import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { AdService } from "../../ad-service";
// eslint-disable-next-line react/display-name

import "./ad-slot-row.m.css";

const AdSlotRow = ({ metadata = {} }) => {
  const adLayout = get(metadata, ["layout"], "Leaderboard");
  const { targetingId: adTargetingId, customCode } = get(metadata, ["config"], {});
  return (
    <div className="component-wrapper" styleName="ad-Wrapper">
      <AdService
        row
        adtype={adLayout}
        customCode={customCode}
        adTargetingId={adTargetingId}
        layoutName="PageBuilder"
        slotId={`PB-${get(metadata, ["rowId"], "")}`}
      />
    </div>
  );
};
AdSlotRow.propTypes = {
  metadata: PropTypes.object
};

export { AdSlotRow };
